const loadSprite = () => {

	// Create a new window event so our Javascript can listen for when the sprite is loaded
	const event = new Event('spriteLoaded');

	var ajax = new XMLHttpRequest();

	ajax.open("GET", "/wp-content/themes/visitjersey-business/dist/img/sprite.svg?v=" + new Date().getTime(), true);
	
	// Disable cache
	ajax.setRequestHeader("Cache-Control", "no-cache, no-store, max-age=0");
	ajax.setRequestHeader("Expires", "Tue, 01 Jan 1980 1:00:00 GMT");
	ajax.setRequestHeader("Pragma", "no-cache");

	ajax.send();
	ajax.onload = function(e) {
		// Only attempt to load it if it is found, otherwise it will load in our 404 page
		if( e.target.status == 200 ) {
			var div = document.getElementById("website-sprite");
			div.innerHTML = ajax.responseText;
		
			// Loop through each <use> element and copy across the viewbox to the parent svg so it scales properly
			var useElements = document.getElementsByTagName('use');

			for (let i = 0; i < useElements.length; i++) {
				var useEl         = useElements[i]; 

				if( useEl.hasAttribute('xlink:href') ) {
					var spriteId      = useEl.getAttribute('xlink:href').replace('#', ''); 
					var spriteEl      = document.getElementById(spriteId);

					if( spriteEl ) {
						var spriteViewbox = document.getElementById(spriteId).getAttribute('viewBox');

						if( spriteViewbox ) {
							useEl.parentNode.setAttribute('viewBox', spriteViewbox);
						}
					}
				}
			};
			
			// Trigger sprite loaded event
			window.dispatchEvent(event);
		};
	};

}

export default loadSprite;